import React from 'react';
import SEOHelmet from '../components/SEOHelmet';
import CategoryGrid from '../components/home/CategoryGrid';
import PopularSearches from '../components/home/PopularSearches';
import TrustBadges from '../components/home/TrustBadges';
import WhyChooseCeremonzy from '../components/home/WhyChooseCeremonzy';
import AdPoster1 from '../components/home/AdPoster1';
import AdPoster2 from '../components/home/AdPoster2';

const HomePage = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Ceremonzy - Premium Wedding Vendor Platform",
    "description": "Discover and book premium wedding vendors for your perfect ceremony. Find photographers, caterers, decorators, and more trusted vendors.",
    "url": "https://ceremonzy.com/",
    "mainEntity": {
      "@type": "Organization",
      "name": "Ceremonzy",
      "description": "India's leading wedding vendor platform",
      "url": "https://ceremonzy.com"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://ceremonzy.com/"
        }
      ]
    }
  };

  return (
    <>
      <SEOHelmet
        title="Ceremonzy - Find Perfect Wedding Vendors | Premium Ceremony Services"
        description="Ceremonzy connects you with India's best wedding vendors. Book photographers, caterers, decorators, and ceremony specialists. Trusted by thousands of couples for unforgettable weddings."
        keywords="Ceremonzy, wedding vendors India, wedding planning, ceremony vendors, wedding photographers, wedding caterers, wedding decorators, Indian wedding services, marriage planning, premium wedding vendors"
        url="/"
        structuredData={structuredData}
      />
      <div className="min-h-screen">
        {/* Section 1: Find Perfect Ceremony Vendor */}
        <CategoryGrid />
        
        {/* Advertisement Poster 1 - Between Section 1 & 2 */}
        <AdPoster1 />
        
        {/* Section 2: Popular Searches */}
        <PopularSearches />
        
        {/* Advertisement Poster 2 - Between Section 2 & 3 */}
        <AdPoster2 />
        
        {/* Section 3: Why Choose Ceremonzy? */}
              <WhyChooseCeremonzy />
        
        <TrustBadges />
      </div>
    </>
  );
};

export default HomePage;